export const checkIsMobile = () => {
  return window.innerWidth < 640;
};

// iOS home-screen apps also report through Safari's navigator.standalone, which predates the media query.
export const checkIsInstalledApp = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  ("standalone" in navigator && navigator.standalone === true);

// iPadOS Safari reports itself as a Mac, so a touch-capable "Mac" is an iPad.
export const checkIsAppleMobileDevice = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (/macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

export const checkIsMobileOrTabletDevice = () => checkIsAppleMobileDevice() || /android/i.test(navigator.userAgent);
